import API from '../axios/API';

export const createBanner = (data) => {
    return async (dispatch, getState) => {
        let response;

        try {
            response = await API.post(`restaurants/:restaurantId/banners`, data);
        } catch (error) {
            response = error;
        }

        return response;
    };
};
